import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Heading from '../../components/Heading'
import TriRoundRow from '../../components/TriRoundRow'
import CenterRow from '../../components/CenterRow'
import Divider from '../../components/Divider'
import CTAButton from '../../components/CTAButton'
import Hero from '../../components/Hero'
import ProductsGrid from '../../components/ProductsGrid'
import AppsAndService from '../../components/AppsAndService'
import LeadForm from '../../components/LeadForm'

import '../../css/products.less'

class ProductsPage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

  	const meta = {
  		description: "We are the complete acoustic cleaner (sonic horn) supplier. With experience dating back to 1989, we can supply or design an acoustic cleaning system to suit your requirements. As a leader in the industry, our team takes your needs seriously. From design to repair and everything in between, we simply blow our competition away.",
  		keywords: "Acoustic Cleaning Systems",
  		headline: "ACS Products: No matter the size of the need, we have a cleaner that will work.",
  		title: "ACS Products: No matter the size of the need, we have a cleaner that will work."
  	}

    const productPages = pages.filter((page) => {
      return page.path.split('/').indexOf('products') > -1 && 'Specifications' in page.data
    }).sort((a, b) => {
			const { data: { Specifications: { Model:aModel } } } = a
			const { data: { Specifications: { Model:bModel } } } = b
			return aModel.toLowerCase().localeCompare(bModel.toLowerCase());
		});

    return (
      <div className="products-page">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
				<Hero headline="Give us a try. You'll be blown away."
					className="applications"
					images={[
						'/images/hero/1.jpg',
						'/images/hero/0.jpg',
						'/images/hero/2.jpg',
					]}
				>
					<LeadForm />
				</Hero>
				<br /><br />
				<div className="container page">
					<CenterRow headline="We offer a broad range of acoustic cleaners.">
						We can customize units to fit a specific installation or material
						requirement. Even exotic materials are possible for pharmaceutical
						and high temperature applications.
					</CenterRow>
				</div>
				<ProductsGrid pages={productPages} />
				<div className="container page">
					<AppsAndService />
				</div>

    	</div>
    )
  }
}

ProductsPage.propTypes = {}
ProductsPage.defaultProps = {}
ProductsPage.data = {
  menuLabel: 'Products',
  menuShortDescription: 'Products for Acoustic Cleaning Services, Inc.'
}
export default ProductsPage



// WEBPACK FOOTER //
// ./products/index.js